import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import './ourpartners.scss';

const PARTNERS = [
    {name: 'Evoca Bank', href: 'https://evoca.am', logo: 'evoca2.png'},
    {name: 'Mottura', href: 'https://www.mottura.it/ru/homepage-russian', logo: 'mottura.png'},
    {name: 'Profal', href: 'https://profal.am', logo: 'profal.png'},
    {name: 'Schindler', href: 'https://ilift.am', logo: 'schindler-logo2.png'},
];

class OurPartners extends Component {
    render() {
        const {translate} = this.props;

        return (
            <section className="cpr-section cpr-section--tight cpr-partners" aria-labelledby="cpr-partners-title">
                <div className="cpr-container cpr-partners__inner">
                    <h2 id="cpr-partners-title" className="cpr-label">{translate('our_partners')}</h2>
                    <ul className="cpr-partners__list">
                        {PARTNERS.map(p => (
                            <li key={p.name}>
                                <a href={p.href} target="_blank" rel="noopener noreferrer">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/general/${p.logo}`}
                                         alt={p.name} loading="lazy"/>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(OurPartners));
